import React, { useState, useEffect } from "react";
import { Segment, Divider } from "semantic-ui-react";
import { SemanticContainer, SemanticSegment } from "./styled";
import { Icon, Pagination } from "semantic-ui-react";
import swal from "sweetalert";

import {
  Container,
  Content,
  Title,
  ContainerInputSearch,
  Input,
  CreateButton,
  SemanticTable,
  StyledLabel,
  SemanticButton,
  ContainerPaginate,
  ButtonIcon,
} from "./styled";
import { withRouter } from "react-router-dom";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import Back from "../../../../components/Admin/TrilhasVoitto/Criar/Back";
import { producaov2 as api } from "../../../../services/apis";
import Loading from "../../../../components/Loading";
import { datePattern } from "../../../../utils/Utils";

const BlogColunistas = props => {
  const [search, setSearch] = useState("");
  const [trails, setTrails] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function getTrails() {
      const t = await api.get("admin/incompany/v3/trails");
      setTrails(t.data);
      setLoading(false);
    }
    getTrails();
  }, []);

  function handleDelete(id) {
    swal(
      {
        title: "Você tem certeza?",
        text: "Não será possível recuperar a trilha deletada",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Sim, apague!",
        closeOnConfirm: false,
      },
      function () {
        api
          .delete(`incompany/v3/trails/${id}`)
          .then(res => {
            swal("Excluido!", "Sua trilha foi excluida com sucesso", "success");
          })
          .catch(err => {
            swal("Aconteceu um erro!", err.toString(), "error");
          });
      }
    );
  }

  return (
    <div style={{width: "100vw", padding:" 0 1rem 0 calc(250px + 1rem)"}}>

      <AdminMenu />
      <SemanticContainer>
        <Back />
        <h2>Listar Trilhas</h2>
        <Divider />
        {loading ? (
          <Loading msg="Buscando trilhas" />
        ) : (
          <Segment>
            <ContainerInputSearch className="ui fluid left icon input">
              <Input
                type="search"
                placeholder="Procurar trilhas"
                value={search}
                onChange={e => setSearch(e.target.value)}
              />
              <Icon name="search icon" />
              <CreateButton to="/admin/trilhas/criar">Criar</CreateButton>
            </ContainerInputSearch>
            <SemanticTable size="big" celled striped>
              <SemanticTable.Header>
                <SemanticTable.Row>
                  <SemanticTable.HeaderCell>Título</SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>Descrição</SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell width={1}>
                    Status
                  </SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell width={1}>
                    Ultima Atualização
                  </SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell width={2}>
                    Opções
                  </SemanticTable.HeaderCell>
                </SemanticTable.Row>
              </SemanticTable.Header>
              <SemanticTable.Body>
                {trails.map((trail, index) => (
                  <SemanticTable.Row key={index}>
                    <SemanticTable.Cell>{trail.title}</SemanticTable.Cell>
                    <SemanticTable.Cell>{trail.description}</SemanticTable.Cell>
                    <SemanticTable.Cell
                      textAlign="center"
                      positive={trail.active}
                      negative={!trail.active}
                    >
                      {trail.active ? "ativa" : "inativa"}
                    </SemanticTable.Cell>
                    <SemanticTable.Cell textAlign="center">
                      {datePattern(trail.updated_at)}
                    </SemanticTable.Cell>
                    <SemanticTable.Cell textAlign="left">
                      <ButtonIcon
                        onClick={() =>
                          window.open(`/admin/trilhas/detalhes/${trail.id}`)
                        }
                      >
                        <Icon
                          name="edit"
                          color={"blue"}
                          title="Editar trilha"
                        />
                      </ButtonIcon>

                      <ButtonIcon onClick={() => handleDelete()}>
                        <Icon
                          name="trash"
                          color={"red"}
                          title="Apagar trilha"
                        />
                      </ButtonIcon>
                    </SemanticTable.Cell>
                  </SemanticTable.Row>
                ))}
              </SemanticTable.Body>
            </SemanticTable>
          </Segment>
        )}
      </SemanticContainer>
      <SemanticContainer>
        <SemanticSegment>
          Grupo Voitto <i class="copyright outline icon"></i>2023
        </SemanticSegment>
      </SemanticContainer>
    </div>
  );
};

export default withRouter(BlogColunistas);
